import { render } from "./BasicLayout.vue?vue&type=template&id=1130ee5c&scoped=true"
import script from "./BasicLayout.vue?vue&type=script&lang=ts"
export * from "./BasicLayout.vue?vue&type=script&lang=ts"

import "./BasicLayout.vue?vue&type=style&index=0&id=1130ee5c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1130ee5c"

export default script